module.exports = __webpack_public_path__ + "static/media/ic_sp_horizontal.6b9afffc.svg";